const InputComponent = ({ question, questionIdMap }) => {
  if (!question.isQuestion) return null;

  return (
    <div
      className="gradingFeedbackInputQuestionContainer"
      style={{
        backgroundColor:
          questionIdMap[question.questionId].EventName ===
          "Answered Incorrectly"
            ? "#FFECEB"
            : "#F7FFED",
      }}
    >
      <div
        className="gradingFeedbackInputQuestionNumberWrapper"
        style={{
          backgroundColor:
            questionIdMap[question.questionId].EventName ===
            "Answered Incorrectly"
              ? "#B53333"
              : "#517145",
        }}
      >
        <h3 className="gradingFeedbackInputQuestionNumber">
          {question.questionNumber}
        </h3>
      </div>
      <div className="gradingFeedbackInputQuestionContentWrapper">
        <h4 className="gradingFeedbackInputQuestionTitle">
          {question.rightColumnText.replaceAll("{input}", "_____")}
        </h4>
        <p className="gradingFeedbackInputQuestionText">
          Your Answer: "{questionIdMap[question.questionId].CustomerAnswer}"
        </p>
        <p className="gradingFeedbackInputQuestionText">
          Correct Answer: "{questionIdMap[question.questionId].CorrectAnswer}"
        </p>
      </div>
    </div>
  );
};

export default InputComponent;
